<template>
  <base-footer :links="links" :socialLinks="socialLinks" logo="/static-appopensalud/img/logos/openlegal360_white.svg" companyName="Openlegal"></base-footer>
</template>

<script>
import es from '@/lang/es/public/footer-opensalud.json'
import en from '@/lang/en/public/footer-opensalud.json'
import BaseFooter from '../../base/BaseFooter.vue'

export default {
  name: 'FooterOpenlegal',
  components: {
    BaseFooter
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  data () {
    return {
      socialLinks: [
        {
          href: 'https://www.facebook.com/openlegal.es',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg',
          alt: 'openlegal social facebook'
        },
        {
          href: 'https://www.instagram.com/openlegal_es/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg',
          alt: 'openlegal social instagram'
        },
        {
          href: 'https://www.linkedin.com/company/openlegalespana/about/?viewAsMember=true',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg',
          alt: 'openlegal social linkedin'
        },
        {
          href: 'https://www.twitter.com/openlegal_es',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter.svg',
          alt: 'openlegal social twitter'
        }
      ],
      links: {
        firstColumn: [
          {
            text: this.$t('client-conditions'),
            href: this.$helpers.getRelativeHref('terms-clients', 'openlegal')
          }
          /* {
            text: this.$t('client-conditions'),
            href: this.$helpers.getAppUrl('/Home/terminos-condiciones-paciente')
          },
          {
            text: this.$t('contact'),
            href: this.$helpers.getAppUrl('/Home/IncidenciasView')
          } */
        ],
        secondColumn: [
          /* {
            text: this.$t('legal-notice'),
            href: this.$helpers.getAppUrl('/Home/aviso-legal')
          },
          {
            text: this.$t('faqs'),
            href: 'https://ayuda.opensalud.es/es'
          } */
        ]
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/public/footers/FooterOpenlegal360.vue